export default __webpack_public_path__ + "static/media/WhitneySSm-Semibold-Adv_Web.08246fd3.woff2";